<script lang="ts">
  import type { StudioIncludes } from '@bond/bruce-api/api/studio/response'
  import StudioCard from './StudioCard.svelte'

  export let imageUrl: string
  export let studios: StudioIncludes<{
    params: object
  }>[]

  $: length = studios.length
  $: halfLength = Math.ceil(length / 2)
</script>

<div class="container" style={`--length: ${length}`}>
  <ul>
    <div>
      {#each studios.slice(0, halfLength) as studio (studio.id)}
        <li>
          <StudioCard {imageUrl} {studio} size="sm" opacity={50} />
        </li>
      {/each}
    </div>
    <div aria-hidden="true">
      {#each studios.slice(0, halfLength) as studio (studio.id)}
        <li>
          <StudioCard {imageUrl} {studio} size="sm" opacity={50} />
        </li>
      {/each}
    </div>
  </ul>
  <ul class="reverse">
    <div>
      {#each studios.slice(halfLength, studios.length) as studio (studio.id)}
        <li>
          <StudioCard {imageUrl} {studio} size="sm" opacity={50} />
        </li>
      {/each}
    </div>
    <div aria-hidden="true">
      {#each studios.slice(halfLength, studios.length) as studio (studio.id)}
        <li>
          <StudioCard {imageUrl} {studio} size="sm" opacity={50} />
        </li>
      {/each}
    </div>
  </ul>
</div>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  .container {
    width: 100%;
    height: max-content;

    ul {
      display: flex;
      justify-content: flex-start;
      overflow: hidden;
      user-select: none;
      gap: 12px;
      list-style-type: none;
      margin: 0.5em 0;
      padding: 0;

      div {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        gap: 12px;
        animation: marquee calc(var(--length, 20) * 40s) linear infinite;
        height: 150px;

        @media screen and (max-width: breakpoints.$breakpoint-sm) {
          height: 100px;
        }

        li {
          height: 100%;
        }
      }

      &.reverse {
        justify-content: flex-end;

        div {
          animation-direction: reverse;
          animation: marquee-reverse calc(var(--length, 20) * 40s) linear
            infinite;
        }
      }

      &:hover {
        div {
          animation-play-state: paused;
        }
      }

      @keyframes marquee {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(calc(-100% - 12px));
        }
      }

      @keyframes marquee-reverse {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(calc(100% + 12px));
        }
      }
    }
  }
</style>
